export default __webpack_public_path__ + "static/media/Collection.5487114c.svg";